import { useEffect, useState } from "react";
import { io as ioClient } from "socket.io-client";
import api, { API_ORIGIN } from "../api";
import UserHeader from "./UserHeader";

export default function UserLayout({ children }) {
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const loadUnreadNotifications = async () => {
    try {
      const { data } = await api.get("/notifications");
      setUnreadNotifications((Array.isArray(data) ? data : []).filter((n) => !n.read).length);
    } catch { /* preserve current badge */ }
  };

  useEffect(() => {
    loadUnreadNotifications();
    const timer = setInterval(loadUnreadNotifications, 30000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!user?.id) return undefined;
    const socket = ioClient(API_ORIGIN, { transports: ["websocket", "polling"], auth: { token: localStorage.getItem("token") } });
    socket.emit("join", `user:${user.id}`);
    socket.on("notification:new", () => setUnreadNotifications((n) => n + 1));
    return () => socket.disconnect();
  }, [user?.id]);

  return (
    <div className="agp-user-shell">
      <UserHeader unreadNotifications={unreadNotifications} />
      <div className="agp-user-content">{children}</div>
    </div>
  );
}
